/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton, SearchInput } from "../../components";
import { useTransactionLogs } from "../../store/useTransactionLogs";
import { TransactionLogsTable } from "./TransactionLogsTable";

let searchTimeout: string | number | NodeJS.Timeout | null | undefined = null;

function TransactionLogsScreen() {
  const { logs, hasNextPage, getTransactionLogs, searchText, setSearchText } =
    useTransactionLogs();

  const [page, setPage] = useState(1);

  useEffect(() => {
    getTransactionLogs(1, 20, "");
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, []);

  useEffect(() => {
    if (searchTimeout) clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      setPage(1);
      getTransactionLogs(1, 20, searchText || "");
    }, 500);

    return () => {
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, [searchText]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Transaction logs
        </h1>
      </div>

      <div className="w-full px-7 py-1 bg-white rounded-xl border-gray-border drop-shadow-none mb-3">
        <SearchInput
          value={searchText}
          onChange={handleSearch}
          placeholder="Search by user, email or id..."
        />
      </div>

      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!logs?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no transaction log yet.
          </p>
        ) : (
          <TransactionLogsTable />
        )}
      </div>

      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              const nextPage = page + 1;
              setPage(nextPage);
              getTransactionLogs(nextPage, 20, searchText || "");
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(TransactionLogsScreen);
